import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getAdminCheckouts } from "../api/adminCheckouts";

const formatDate = (value) => value ? new Date(value).toLocaleDateString("nl-BE") : "-";
const formatDateTime = (value) => value ? new Date(value).toLocaleString("nl-BE") : "-";

export default function AdminCheckouts() {
  const { data = [], isLoading, isError, error } = useQuery({
    queryKey: ["admin", "checkouts"],
    queryFn: getAdminCheckouts
  });

  if (isLoading) return <div className="loading-state">Check-outs laden...</div>;

  return (
    <section className="page">
      <header className="page-header">
        <div>
          <h1 className="page-title">Check-outs</h1>
          <p className="page-subtitle">Werk van vandaag en overzicht van bevestigde trailer ophalingen.</p>
        </div>
      </header>

      {isError ? (
        <div className="panel panel-pad error-text">{error?.response?.data?.error || "Check-outs ophalen mislukt."}</div>
      ) : data.length === 0 ? (
        <div className="panel empty-state">Geen openstaande of bevestigde check-outs gevonden.</div>
      ) : (
        <div className="panel table-panel">
          <table className="data-table">
            <thead>
              <tr>
                <th>Reservatie</th>
                <th>Klant</th>
                <th>Trailer</th>
                <th>Ophaaldatum</th>
                <th>Status</th>
                <th>Foto's</th>
                <th>Schade?</th>
                <th>Bevestigd</th>
                <th>Actie</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr key={`${item.type}-${item.checkoutInspectionId || item.reservationId}`}>
                  <td>#{item.reservationId}</td>
                  <td>{item.reservation?.firstName || item.customer?.firstName || ""} {item.reservation?.name || item.customer?.lastName || "-"}</td>
                  <td>{item.trailer?.name || `#${item.reservation?.trailerId || "-"}`}</td>
                  <td>{formatDate(item.pickupDate || item.reservation?.startDate)}</td>
                  <td>
                    {item.checkoutStatus === "PENDING" ? (
                      <span className="badge warning">Nog uit te checken</span>
                    ) : (
                      <span className="badge success">Bevestigd</span>
                    )}
                    <span className="badge info" style={{ marginLeft: 6 }}>{item.reservation?.status || item.status}</span>
                  </td>
                  <td>{item.photos?.length || 0}</td>
                  <td>{item.openDamageCount ? <span className="badge danger">Ja</span> : <span className="badge success">Nee</span>}</td>
                  <td>{formatDateTime(item.confirmedAt)}</td>
                  <td>
                    {item.checkoutStatus === "PENDING" ? (
                      <Link className="button" to={`/admin/checkouts/reservation/${item.reservationId}/start`}>
                        Checkout uitvoeren
                      </Link>
                    ) : (
                      <Link className="button secondary" to={`/admin/checkouts/${item.checkoutInspectionId}`}>
                        Bekijk checkout
                      </Link>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
